import {
  PermissionCategory,
  PermissionLevel,
  SCOPED_CATEGORIES,
  ScopeMode,
} from '@/client/custom-roles';
import { TranslationFunctionType } from '@/common/types';
import { mixed, object, string } from 'yup';

export type CustomRoleFormValues = {
  name: string;
  scopeMode: ScopeMode | null;
  permissions: Record<PermissionCategory, PermissionLevel>;
};

export const requiresScopeMode = (
  permissions: Record<PermissionCategory, PermissionLevel>,
): boolean =>
  SCOPED_CATEGORIES.some(
    (category) => permissions[category] !== PermissionLevel.NONE,
  );

export const customRoleSchema = (t: TranslationFunctionType) =>
  object({
    name: string()
      .trim()
      .required(t('error.requiredField'))
      .max(255, t('account.rolesAccess.builder.name.tooLong')),
    scopeMode: mixed<ScopeMode>()
      .oneOf(Object.values(ScopeMode))
      .nullable()
      .test(
        'scope-mode-required',
        t('account.rolesAccess.builder.scope.required'),
        function (value) {
          const { permissions } = this.parent as CustomRoleFormValues;

          return !requiresScopeMode(permissions) || !!value;
        },
      ),
  });
